const glossary = {
  // ensure non-spacing for URLs
  ROUTE_CAMPS: ['competition', 'competitions'],
  ROUTE_OPPS_DEPRECATED: ['opportunity', 'opportunities'],
  ROUTE_OPPS: ['event', 'events'],
  ROUTE_CAUSES: ['event', 'events'],
  ROUTE_ORGS: ['organisation', 'organisations'],
  // rest
  GOAL_TYPES: ['event type', 'event types'],
  OPPS: ['event', 'events'],
  APPS: ['application', 'applications'],
  OPP_WORKSHOPS: ['workshop', 'workshops'],
  CAMPS: ['competition', 'competitions'],
  CATS: ['subject', 'subjects'],
  USERS: ['student', 'students'],
  ORGS: ['institution', 'institutions'],
  EVENTS: ['event', 'events'],
  TEAMS: ['team', 'teams'],
  ROUNDS: ['round', 'rounds'],
  SCHOOLS: ['school', 'schools'],
  CONTACTS: ['contact', 'contacts'],
  LOGINS: ['login', 'logins'],
  LEARNERS: ['learner', 'learners'],
  MENTORS: ['mentor', 'mentors'],
  RSVPS: ['rsvp', 'rsvps'],
  SUPPORTERS: ['participant', 'participants'],
  COMMITMENTS: ['commitment', 'commitments'],
  ENROLMENTS: ['enrolment', 'enrolments'],
  REG_SCHEDS: ['registration schedule', 'registration schedules'],
  SITENAME: ['Growsmart', 'Growsmart'],
  FACEBOOK_LINK: ['https://www.facebook.com/Growsmart', 'https://www.facebook.com/Growsmart'],
  TWITTER_LINK: [
    'https://www.twitter.com/browniepointsSA',
    'https://www.twitter.com/browniepointsSA'
  ],
  YOUTUBE_LINK: [
    'https://www.youtube.com/channel/UCMw5_wI7FG3xiCtQ5uK5wUA',
    'https://www.youtube.com/channel/UCMw5_wI7FG3xiCtQ5uK5wUA'
  ],
  CONTACT_EMAIL: ['growsmart@growthpoint.co.za', 'growsmart@growthpoint.co.za'],
  PHYSICAL_ADDRESS: [
    '257 Main Rd, Claremont, Cape Town, 7708, South Africa',
    '257 Main Rd, Claremont, Cape Town, 7708, South Africa'
  ],
  ACCOUNT_CATEGORIES_LABEL: ['Subject(s) you are mentoring', 'Subject(s) you are mentoring'],
  ACCOUNT_CATEGORIES_SUBLABEL: [
    'Subjects will appear here once sign ups happen',
    'Subjects will appear here once sign ups happen'
  ],
  ORG_LOGO_LABEL: ['Profile picture', 'Profile picture'],
  GOAL_TYPE_LABEL: ['Event type', 'Event type'],
  GOAL_TYPE_SUBLABEL: [
    `Pick whether this event is a workshop or a round`,
    `Pick whether this event is a workshop or a round`
  ],
  OUTCOME_TARGET_LABEL: [
    'Maximum number of slots for this round',
    'Maximum number of slots for this round'
  ]
}

const singularGlossary = key => {
  const returnVal = glossary[`${key}S`][0]

  // return the singular value for both the singular and plural destructuring
  return [returnVal, returnVal]
}

const localize = (string, count = null) => {
  const [singular, plural] = glossary[string] || singularGlossary(string) || ''
  return count === 1 ? singular : plural
}

export default localize
